<div
  class="content-wrapper k-d-flex k-overflow-hidden k-pos-relative noselect tb"
  appEmptyCalendarSpaceInteraction
  #timeBlockBody
>
  @if (
    timeBlockComponentItem.timeBlockModel.fixInterval === null &&
    (calendarViewMode === CalendarView.DayGrid || calendarViewMode === CalendarView.WeekGrid)
  ) {
    <div class="event-time k-mt-2 tb">
      <div class="event-duration k-align-items-center k-justify-content-between k-w-full tb">
        <div class="start-and-end">
          <span class="value tb">{{
            timeBlockComponentItem.timeBlockModel.start | date: "HH:mm"
          }}</span>
          <span>&nbsp;—&nbsp;</span>
          <span class="value pr-1 tb">{{
            timeBlockComponentItem.timeBlockModel.end | date: "HH:mm"
          }}</span>
        </div>
        <div class="duration k-align-items-center k-d-flex">
          <fa-icon [icon]="faClock" [size]="'xs'" class="k-mt-0.5"></fa-icon>
          <span class="k-ml-1">{{
            timeBlockComponentItem.timeBlockModel | timeBlockTimeDifference
          }}</span>
        </div>
      </div>
    </div>
  }

  <div
    class="text tb"
    [ngClass]="timeBlockComponentItem.timeBlockModel.fixInterval !== null ? '' : 'pt-2 pb-3'"
  >
    @if (
      timeBlockComponentItem.timeBlockModel.fixInterval === null &&
      calendarViewMode === CalendarView.MonthGrid
    ) {
      <div
        [style.background-color]="timeBlockComponentItem | timeBlockColor"
        class="week-view-bullet-point"
      ></div>
    }
    <h4
      class="title k-h-full tb"
      [style.background-color]="timeBlockComponentItem | timeBlockColor"
    >
      {{ timeBlockComponentItem | timeBlockTitle }}
    </h4>
    @if (
      timeBlockComponentItem.timeBlockModel.fixInterval === null &&
      (calendarViewMode === CalendarView.DayGrid || calendarViewMode === CalendarView.WeekGrid)
    ) {
      <div class="description k-h-full tb">Cur: {{ timeBlockComponentItem.id }} <br /></div>
    }
  </div>
</div>
